module.exports = __webpack_public_path__ + "static/img/co5.774ef2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cooperation/co5.jpg
// module id = siAx
// module chunks = 11